import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { PriceLabelValue } from './price-label.types';
import { AppCurrency } from 'src/app/types/currency';
import { APP_CONFIG, AppConfig } from 'src/app/config/app-config';

@Component({
  selector: 'app-price-label',
  templateUrl: './price-label.component.html',
  styleUrls: ['./price-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceLabelComponent {
  public readonly appCurrencies = AppCurrency;

  public levoPrice: string | null = null;

  constructor(@Inject(APP_CONFIG) private readonly appConfig: AppConfig) {}
  @Input() value: PriceLabelValue | null = null;
  @Input() isCompact: boolean = false;
  @Input() noIcon: boolean = false;

  @Input() public secondaryCurrencyAlight: 'start' | 'end' | 'inline' = 'end';

  ngOnChanges() {
    const fullPrice = Math.round(
      parseInt(`${this.value?.bigPart}${this.value?.end}`) *
        this.appConfig.eurToLevaFixedRate
    );
    const priceString = fullPrice.toString();
    this.levoPrice = `${
      priceString.slice(0, priceString.length - 2) || '0'
    }.${priceString.slice(priceString.length - 2)}`;
  }
}
